export const langs = [
    { value: "en", label: "English" },
    { value: "de", label: "Deutsch" },
]

export const langCodes = langs.map(lang => lang.value)